import { dataFetcher } from 'core/services/requestHandler';   

const getConfigurations = async (data = {}, config = {}) => {
  return dataFetcher('settings/getConfigurations', data, { ...config});
};

const getAllowedConfigValues = async (data = {}, config = {}) => {
  return dataFetcher('settings/getAllowedConfigValues', data, {...config});
};

const updateConfiguration = async (data = {}, config = {}) => { 
  return dataFetcher('settings/updateConfiguration', data, {...config});
};

export { getConfigurations, getAllowedConfigValues, updateConfiguration };
